var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95119 0H10.4558H18.3297C20.9316 0 21.8103 2.04837 21.9244 3.07256C21.9814 5.51923 22.0613 11.1636 21.9244 14.1679C21.7874 17.1722 19.1285 17.9233 17.8162 17.9233H10.798C9.99922 18.663 8.16195 20.4155 7.20337 21.5079C6.2448 22.6004 5.89104 21.6217 5.83398 20.9958V17.9233H3.43766C0.424991 17.9233 -0.0999448 15.3059 0.0141716 13.9972V3.75535C0.0141716 0.75107 2.63885 0 3.95119 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3525 3.83232H10.2998L10.3026 3.885L10.6908 11.1321L10.6934 11.1794H10.7408H11.9055H11.9529L11.9554 11.1321L12.3436 3.885L12.3465 3.83232H12.2937H10.3525Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.6922,
    y: 12.7615,
    width: 1.26471,
    height: 0.876471,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.4a1164b2.svg";
export { ForwardRef as ReactComponent };